import './Home.css';
import './About.css';
import about_bg from './assets/about_bg.webp';

function About() {
    return (
        <>
            <div className="home-background" style={{ backgroundImage: `url(${about_bg})` }}>
                <div className="text-overlay">
                    <h1 className="about-heading">About Me</h1>
                    <div className="about-text">
                        <p>Family Oriented</p>
                        <p>Nature Lover</p>
                        <p>Technlogy Enthusiast</p>
                        <p>
                            Founding Member of the OWL<sup className="about-superscript">2</sup> Club 
                        </p>
                        <p>Lover of Good Food</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;